import React from 'react';
import { Col, Card, CardBody, FormGroup, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';

const ClientConnection = () => {
  const { register, handleSubmit } = useForm();
  const onSubmit = (form) => {
    // TODO: not yet implemented — this Settings form's Save is currently a no-op.
    console.log('### form ###', form);
  };
  return (
    <Card>
      <CardBody>
        <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
          <FormGroup row>
            <Col md="1">
              <label htmlFor="protocol">Protocol</label>
            </Col>
            <Col md="3">
              <select {...register('protocol')} className="form-control">
                <option value="http">http</option>
                <option value="https">https</option>
              </select>
            </Col>
            <Col md="1">
              <label htmlFor="domain">Domain</label>
            </Col>
            <Col md="3">
              <input {...register('domain')} type="text" className="form-control" placeholder="domain.co.nz" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="1">
              <label htmlFor="port">Port</label>
            </Col>
            <Col md="3">
              <input {...register('port')} type="text" className="form-control" placeholder="port" />
            </Col>
            <Col md="1">
              <label htmlFor="path">Path</label>
            </Col>
            <Col md="3">
              <input {...register('path')} type="text" className="form-control" placeholder="sync-client" />
            </Col>
          </FormGroup>
          <div className="float-end">
            <Button type="submit" color="primary">
              Save
            </Button>
          </div>
        </form>
      </CardBody>
    </Card>
  );
};

export default ClientConnection;
